module.exports = __webpack_public_path__ + "img/adoa.2ed6b421.webp";